import styled, { css } from "styled-components"
import { Link } from "gatsby"
import { Flex } from "../Flex"
import React from "react"
import media from "../../utils/media"
import { contain } from "../Flex"
import theme from "../../utils/theme"
import { toRem } from "../../utils"
import { useContext } from "react"
import { HeaderContext } from "./Header"

const height = toRem(120)

const withOpen = Component => props => {
  const { open } = useContext(HeaderContext)
  const newProps = { ...props, open }

  return <Component {...newProps} />
}

export const Container = withOpen(styled(({ children, ...props }) => {
  return (
    <Flex fluid {...props}>
      <Nav>{children}</Nav>
    </Flex>
  )
})`
  z-index: 10;
  background: ${props =>
    props.secondary
      ? `linear-gradient(90deg,rgba(252, 180, 0, 1) 0%, rgba(249, 126, 0, 1) 100%)`
      : `transparent`};
  background: ${props => (props.open ? "#fff" : null)};
  position: ${props => (!props.secondary ? "absolute" : null)};

  ${media.phone`
    ${props => (props.open ? "position: fixed" : null)};
    z-index: 9;
  `}
`)

const menuHover = css`
  &:hover {
    opacity: 0.8;
  }
`

export const Item = styled(Link)`
  padding: 3rem 2rem;
  text-transform: capitalize;
  font-weight: 600;
  text-decoration: none;
  color: inherit;

  ${menuHover}
`
export const Img = styled.img`
  margin: 0;
  padding-right: 2rem;
  ${menuHover}
  min-width: 115px;
`
export const Logo = ({ to, ...rest }) => (
  <Link to={to}>
    <Img {...rest} />
  </Link>
)

export const Nav = styled.div`
  display: flex;
  align-items: center;
  height: ${height};
  width: 100%;
  position: relative;
  ${contain};
`

export const NavHeader = styled.div`
  display: inline;
`

export const NavTitle = styled.div`
  display: inline-block;
  font-size: 22px;
  color: #fff;
  padding: 10px;
`

export const NavBtn = styled.div`
  display: none;
  z-index: 1000;
  ${media.phone`
    display: inline-block;
    position: absolute;
    height: ${height}
    display: flex;
    align-items: center;
    justify-content: flex-end;
    right: ${toRem(26)};
  `}
`

const open = css`
  height: calc(100vh);
  height: calc(var(--vh, 1vh) * 100);
  overflow-y: auto;
  opacity: 1;
`

const close = css`
  height: 0px;
  opacity: 0;
`


export const NavLinks = styled.div`
  display: flex;
  width: 100%;
  float: right;
  justify-content: space-between;
  transition: height 0.5s ease 0s;

  ${media.phone`
    user-select: none;
    position: absolute;
    width: 100%;
    height: 0px;
    flex-direction: column;
    align-items: flex-start;
    overflow-y: hidden;
    display: flex;
    left: 0px;
    top: 0;
    background-color: #fff;
    padding: 0 26px;
    justify-content: center;
    z-index: 0;

    ${props => (props.open ? open : close)};
  `}
`
const sharedNavStyle = css`
position: relative;
text-transform: capitalize;
display: inline-block;
padding: 0px 25px;
text-decoration: none;
font-size: ${toRem(18)};
color: #fff;
font-weight: 600;

${media.phone`
  padding: 0 10px;
  color: ${theme.colors.text}
  font-weight: 500;
  font-size: 22px;
  margin-bottom: ${toRem(18)};
`}

&:hover {
  cursor: pointer;
}

&:hover {
  opacity: 0.8;
}

${media.phone`
  display: block;
  width: 100%;
`}
`

export const NavLink = styled(Link)`
 ${sharedNavStyle}
`

export const NavExternalLink = styled.a`
 ${sharedNavStyle}
`

export const NavCheck = styled.div`
  display: none;

  &:not(:checked) ~ ${NavLinks} {
    height: 0px;
  }

  &:not(:checked) ~ ${NavLinks} {
    height: calc(100vh - 50px);
    height: calc(calc(var(--vh, 1vh) * 100) - 50px);
    overflow-y: auto;
  }
`

export const Label = styled.label`
  ${media.phone`
    display: inline-block;
    width: 50px;
    height: 50px;
    padding: 13px;
    cursor: pointer;
  `}
`

export const Span = withOpen(styled.span`
  ${media.phone`
    display: flex;
    width: 25px;
    margin-bottom: 5px;
    border-top: 4px solid;
    border-color: ${props => (props.open ? theme.colors.text : "#fff")};
    border-radius: 2px;
  `}
`)
